<!--  -->
<template>
  <div class="box">
    <div class="headLine">SDS查询</div>
    <div class="serachText">
      <van-field v-model="text" placeholder="请输入化学品名称" />
    </div>
    <div class="searchBtn" @click="handleSeach">搜索</div>
    <div class="safeInfo" @click="handleTaboo">禁忌表</div>
    <div class="safeInfo" @click="handleCheck">去考核</div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { Notify } from "vant";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      text: null,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleSeach() {
      if (this.text) {
        this.$router.push({
          name: "scanInfoSearch",
          query: { text: this.text },
        });
      } else {
        Notify({ type: "danger", message: "请输入化学品名称", duration: 1000 });
      }
    },
    handleCheck() {
      this.$router.push("/checkAccess");
    },
    handleTaboo() {
      this.$router.push("/taboo");
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.box {
  padding: 20px;
  .headLine {
    margin-top: 10px;
    margin-bottom: 10px;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #000;
  }

  .searchBtn {
    margin: 0 auto;
    margin-top: 20px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background: #57aee8;
    border-radius: 10px;
    font-size: 15px;
    width: 180px;
    height: 40px;
  }
  .safeInfo {
    margin-top: 20px;
    width: 100%;
    font-size: 18px;
    height: 100px;
    background: #5bafe6;
    color: #fff;
    text-align: center;
    line-height: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/scan1.vue